/* eslint-disable no-shadow */
/* eslint-disable prefer-template */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import AllPlayersFiltersV3 from './AllPlayersFiltersV3';
import AllPlayersListV3 from './AllPlayersListV3';
import { genderValues, playerTypeValues } from '../../../utils/eventDeskConstants';

import * as drawEditActions from '../../../actions/draw-edit-actions';
import useSortFilterPlayersTeams from './Filters/useSortFilterPlayersTeams';
import EventDeskTabLayout from '../EventDeskTabLayout';

import styles from './playersTab.scss';

const PlayersTabV3 = (props) => {
    const { eventId, players, teams, divisions, sendMessage, utrType, setMove, sportTypeId, showHighSchoolName, isFlexLeagueEvent } = props;
    const dispatch = useDispatch();

    const defaultFilterValues = {
        gender: '',
        playerType: '',
        selectedDivs: [],
        selectedDraws: [],
        selectedDates: [],
        notInDraw: false,
    };

    const [playerListFilter, setPlayerListFilter] = useState(''); // filter query
    const [filters, setFilters] = useState(defaultFilterValues);
    const [filterInputs, setFilterInputs] = useState(defaultFilterValues);
    const [filterModal, setFilterModal] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const filteredDivisions = divisions
        .filter(div => {
            if (!filters.playerType) {
                return true;
            }
            return playerTypeValues[filters.playerType] === div.divisionFormatTypeId;
        })
        .filter(div => {
            if (!filters.gender) {
                return true;
            }
            return genderValues[filters.gender] === div.genderId;
        })
        .filter(div => {
            if (!filters.selectedDates.length) {
                return true;
            }
            return filters.selectedDates.includes(div.specificDivisionDateUtc);
        });

    const {
        filteredSortedPlayers,
        filteredSortedTeams,
        maxSortedTeams,
        maxSortedPlayers,
        setSortState,
        sortState,
        hasLoadMore,
        setHasLoadMore,
        hasLoadMoreButton,
    } = useSortFilterPlayersTeams({
        filters, playerListFilter, divisions, players, teams, filteredDivisions, utrType,
    });

    useEffect(() => {
        dispatch(drawEditActions.getOrganizerRatings({ eventId }));
    }, [eventId]);

    const handleFilterClick = (type) => {
        dispatch(drawEditActions.setResetTimer(true));
        setFilterModal(filterModal ? '' : type);
    };

    const handleFilterUpdate = (filterUpdate, submit) => {
        dispatch(drawEditActions.setResetTimer(true));
        dispatch(drawEditActions.setSelected([]));
        dispatch(drawEditActions.setSelectedTeams([]));

        setFilterInputs({
            ...filterInputs,
            ...filterUpdate,
        });
        if (submit) {
            setIsLoading(true);
            setHasLoadMore(false);
            setFilters({
                ...filterInputs,
                ...filterUpdate,
            });
            setFilterModal('');
        }
    };

    const handleFilterSubmit = () => {
        setFilters(filterInputs);
        setFilterModal('');
        setHasLoadMore(false);
    };

    const clearFilters = () => {
        setFilters(defaultFilterValues);
        setFilterInputs(defaultFilterValues);
        setFilterModal('');
        setHasLoadMore(false);
        setIsLoading(true);
        dispatch(drawEditActions.setSelected([]));
        dispatch(drawEditActions.setSelectedTeams([]));
    };

    const updatePlayersListFilter = (value) => {
        dispatch(drawEditActions.setResetTimer(true));
        setPlayerListFilter(value);
    };

    const closeModals = () => {
        setFilterModal('');
    };

    useEffect(() => {
        setIsLoading(false);
    }, [maxSortedPlayers?.length, maxSortedTeams?.length]);

    useEffect(() => {
        if (maxSortedPlayers?.length === filteredSortedPlayers?.length) {
            setIsLoading(false);
        }
        if (maxSortedTeams?.length === filteredSortedTeams?.length) {
            setIsLoading(false);
        }
    }, [filterInputs]);

    const haveFiltersChanged = JSON.stringify(filters) !== JSON.stringify(defaultFilterValues);

    return (
        <EventDeskTabLayout className={styles.playersTab}>
            <div className={styles.content}>
                <AllPlayersFiltersV3
                    filters={filters}
                    filterInputs={filterInputs}
                    filterModal={filterModal}
                    handleFilterClick={handleFilterClick}
                    handleFilterUpdate={handleFilterUpdate}
                    handleFilterSubmit={handleFilterSubmit}
                    filteredDivisions={filteredDivisions}
                    haveFiltersChanged={haveFiltersChanged}
                    clearFilters={clearFilters}
                    playerListFilter={playerListFilter}
                    updatePlayersListFilter={updatePlayersListFilter}
                    closeModals={closeModals}
                />
                <AllPlayersListV3
                    eventId={eventId}
                    utrType={utrType}
                    divisions={divisions}
                    filteredDivisions={filteredDivisions}
                    sendMessage={sendMessage}
                    setMove={setMove}
                    sportTypeId={sportTypeId}
                    showHighSchoolName={showHighSchoolName}
                    filters={filters}
                    filteredSortedPlayers={filteredSortedPlayers}
                    filteredSortedTeams={filteredSortedTeams}
                    maxSortedPlayers={maxSortedPlayers}
                    maxSortedTeams={maxSortedTeams}
                    setSortState={setSortState}
                    sortState={sortState}
                    hasLoadMore={hasLoadMore}
                    setHasLoadMore={setHasLoadMore}
                    isLoading={isLoading}
                    hasLoadMoreButton={hasLoadMoreButton}
                    isFlexLeagueEvent={isFlexLeagueEvent}
                />
            </div>
        </EventDeskTabLayout>
    );
};

PlayersTabV3.propTypes = {
    eventId: PropTypes.string,
    players: PropTypes.arrayOf(any).isRequired,
    teams: PropTypes.arrayOf(any).isRequired,
    divisions: PropTypes.arrayOf(any).isRequired,
    sendMessage: PropTypes.func.isRequired,
    utrType: PropTypes.string.isRequired,
    setMove: PropTypes.func.isRequired,
    sportTypeId: PropTypes.string.isRequired,
    showHighSchoolName: PropTypes.bool,
    isFlexLeagueEvent: PropTypes.bool,
};

PlayersTabV3.defaultProps = {
    eventId: '',
    showHighSchoolName: false,
    isFlexLeagueEvent: false,
};

export default PlayersTabV3;
